import styles from '../styles';

const compactContentContainerStyles = styles.alignItemsBaseline;

export {
    // eslint-disable-next-line import/prefer-default-export
    compactContentContainerStyles,
};
